import consumer from './consumer'

export function wsInitialize ({
  channel = '',
  initialParams = {},
  onReceive = () => { },
  onConnect = () => { },
  onDisconnect = () => { },
  onReject = () => { },
  onInitialize = () => { }
}) {
  return consumer.subscriptions.create(
    { channel, ...initialParams },
    {
      connected: onConnect,
      disconnected: onDisconnect,
      rejected: onReject,
      initialized: onInitialize,
      received: (data) => onReceive(data)
    }
  )
}
